import { useAnalytics } from "@codat/analytics";
import { useUserState } from "portal-ui-remote/UserStateContext";
import { useEffect } from "react";
import { useLocation } from "react-router-dom";

import { analyticsPageNames } from "components/NavContainer/utils";

const usePageViewEvents = () => {
  const loc = useLocation();
  const { sendPageViewEvent } = useAnalytics();
  const { userState } = useUserState();

  useEffect(() => {
    if (!userState) return;
    const matchingPage = analyticsPageNames.find((page) =>
      loc.pathname.match(page.path)
    );
    // Note: the first match will be used, so the order of the analyticsPageNames array matters
    if (matchingPage) {
      sendPageViewEvent(matchingPage.name);
    }
  }, [userState, loc.pathname, sendPageViewEvent]);
};

export default usePageViewEvents;
